export function accordion(node, isOpen) {
    let initialHeight = node.offsetHeight;
    let totalHeight = node.children[0].offsetHeight;
    return {
        update(isOpen) {
            let animation = node.animate(
                [
                    {
                        height: totalHeight + 'px',
                        overflow: 'hidden'
                    },
                    {
                        height: initialHeight + 'px',
                        overflow: 'hidden'
                    }
                ],
                { duration: 100, fill: 'both' }
            );
            animation.pause();
            if (!isOpen) {
                animation.play();
            } else {
                animation.reverse();
            }
        }
    };
}